import { emptyPart, gradeFor, hasScoreCounts, percentageFor, schoolYears } from './toetsUtils';

function NumericField({ label, value, onChange, max, integer = false, disabled = false, readOnly = false, id }) {
  return <div className="col-6 col-md">
    <label className="form-label" htmlFor={id}>{label}</label>
    <input id={id} className="form-control" type="number" min="0" max={max} step={integer ? '1' : '0.01'}
      value={value ?? ''} disabled={disabled} readOnly={readOnly} onChange={e => onChange(e.target.value)} />
  </div>;
}
export function ScoreFields({ value, onChange, disabled = false, part = false, prefix = 'toets' }) {
  const computed = hasScoreCounts(value);
  const update = (key, v) => {
    const next = { ...value, [key]: v };
    if (key === 'correct_count' || key === 'incorrect_count') {
      next.grade = gradeFor({ ...next, grade: '' });
    }
    onChange(next);
  };
  return <div className="row g-3">
    <NumericField id={`${prefix}-correct`} label="Aantal goed" integer max={1000000} value={value.correct_count} disabled={disabled} onChange={v => update('correct_count', v)} />
    <NumericField id={`${prefix}-incorrect`} label="Aantal fout" integer max={1000000} value={value.incorrect_count} disabled={disabled} onChange={v => update('incorrect_count', v)} />
    {part && <NumericField id={`${prefix}-percentage`} label={computed ? 'Percentage (automatisch)' : 'Percentage'} max={100} value={percentageFor(value)} disabled={disabled} readOnly={computed} onChange={v => update('percentage', v)} />}
    <NumericField id={`${prefix}-grade`} label={computed ? 'Cijfer (automatisch)' : 'Cijfer (0–10)'} max={10} value={gradeFor(value)} disabled={disabled} readOnly={computed} onChange={v => update('grade', v)} />
  </div>;
}
export default function ToetsFields({ value, onChange, disabled = false, templateOnly = false, titleChange }) {
  const update = (key, v) => onChange({ ...value, [key]: v });
  return <>
    <div className="mb-3">
      <label className="form-label" htmlFor="toets-title">Titel *</label>
      <input id="toets-title" className="form-control" value={value.title} maxLength={200} required disabled={disabled}
        autoComplete="off"
        onChange={e => titleChange ? titleChange(e.target.value) : update('title', e.target.value)} />
      {!templateOnly && !disabled && <div className="form-text">Voer een eigen titel in, of kies hierboven een standaardtoets.</div>}
    </div>
    {!templateOnly && <>
      <div className="row g-3 mb-3">
        <div className="col-sm-6"><label className="form-label" htmlFor="toets-year">Schooljaar</label>
          <input id="toets-year" className="form-control" list="toets-years" value={value.school_year || ''} placeholder="2026-2027"
            pattern="[0-9]{4}-[0-9]{4}" maxLength={9} disabled={disabled} onChange={e => update('school_year', e.target.value)} />
          <datalist id="toets-years">{schoolYears([value.school_year]).map(y => <option key={y} value={y} />)}</datalist>
        </div>
        <div className="col-sm-6"><label className="form-label" htmlFor="toets-date">Datum</label>
          <input id="toets-date" type="date" className="form-control" value={value.test_date || ''} disabled={disabled} onChange={e => update('test_date', e.target.value)} />
        </div>
      </div>
      <ScoreFields value={value} onChange={onChange} disabled={disabled} />
      <p className="form-text mt-2">Bij ingevulde aantallen goed én fout wordt het cijfer automatisch berekend: goed ÷ (goed + fout) × 10, afgerond op twee decimalen. Bij 0 goed en 0 fout blijft het cijfer leeg. Zonder beide aantallen kun je het cijfer zelf invullen. Totaalscores staan los van de onderdelen.</p>
    </>}
    <div className="d-flex flex-wrap justify-content-between align-items-center mt-4 mb-3 gap-2">
      <h3 className="h5 m-0">Onderdelen <small className="text-muted">(optioneel)</small></h3>
      {!disabled && <button type="button" className="btn btn-outline-primary btn-sm" disabled={value.parts.length >= 100}
        onClick={() => update('parts', [...value.parts, templateOnly ? { title: '' } : emptyPart()])}>+ Onderdeel toevoegen</button>}
    </div>
    {value.parts.map((p, index) => <fieldset className="toets-part" key={index} disabled={disabled}>
      <legend className="float-none w-auto fs-6 px-2">Onderdeel {index + 1}</legend>
      <div className="d-flex gap-2 mb-3 align-items-end">
        <div className="flex-grow-1"><label className="form-label" htmlFor={`part-title-${index}`}>Titel *</label>
          <input id={`part-title-${index}`} className="form-control" maxLength={200} required value={p.title}
            onChange={e => update('parts', value.parts.map((part, i) => i === index ? { ...part, title: e.target.value } : part))} />
        </div>
        {!disabled && <button type="button" className="btn btn-outline-danger" aria-label={`Verwijder onderdeel ${index + 1}`}
          onClick={() => update('parts', value.parts.filter((_, i) => i !== index))}>Verwijder</button>}
      </div>
      {!templateOnly && <ScoreFields prefix={`part-${index}`} part value={p} disabled={disabled}
        onChange={part => update('parts', value.parts.map((v, i) => i === index ? part : v))} />}
    </fieldset>)}
    {value.parts.length === 0 && <p className="text-muted">Geen onderdelen toegevoegd.</p>}
    {!templateOnly && !disabled && value.parts.length > 0 && <p className="form-text">Bij ingevulde aantallen goed én fout worden het percentage en het cijfer automatisch berekend. Zonder beide aantallen kun je deze zelf invullen.</p>}
  </>;
}
